import {
  CompareOperator,
  DisplayFormatEnum,
  FormTemplateFieldAutopopulateConfig,
  TransformValueTypeEnum
} from '../../shared/autopopulate/autopopulate.model';
import { DEWS_MEDICAL_HISTORY_FIELDS } from '../../shared/consult-forms/dry-eye-forms/dews-iii/dews-iii-medical-history/dews-iii-medical-history.schema';

function simpleField(incomingDataValuePath: string): FormTemplateFieldAutopopulateConfig[] {
  return [{
    incomingDataValuePath,
    mapConditionConfig: { comparisonOperator: CompareOperator.none },
    transformValueConfig: {
      typeConfig: { type: TransformValueTypeEnum.none },
      displayFormat: DisplayFormatEnum.none
    }
  }];
}

export const dewsIIIMedicalHistoryAutopopulateConfig: {
  [key: string]: FormTemplateFieldAutopopulateConfig[];
} = {
  ...DEWS_MEDICAL_HISTORY_FIELDS.reduce(
    (acc, f) => {
      acc[f.key] = simpleField(f.incomingDataValuePath);
      return acc;
    },
    {} as { [key: string]: FormTemplateFieldAutopopulateConfig[] }
  ),
  medications: [
    {
      incomingDataValuePath: 'generalMedications',
      mapConditionConfig: { comparisonOperator: CompareOperator.notEmpty },
      transformValueConfig: {
        typeConfig: { type: TransformValueTypeEnum.none },
        displayFormat: DisplayFormatEnum.medication
      }
    }
  ]
};
